import React, { useContext, useEffect, useState } from 'react';
import { EditCustomerContext, IEditCustomerContext } from '../../../editCustomerState/editCustomerContext';
import { ILocalizationContext, LocalizationContext } from './localizationState/localizationContext';
import { FormSideTabs } from 'components/EntityForm/FormSideTabs';
import { FormSideTab } from 'components/EntityForm/FormSideTab';
import { NoDataNew } from 'components/NoResultsFound/NoDataNew';
import { LanguageBar } from './components/LanguageBar';
import { LocalizationGroup } from './components/LocalizationGroup';
import { ModalWindows } from './components/ModalWindows';
import classNames from 'classnames';

interface IProps {
	isVisible: boolean;
}

export const LocalizationForm: React.FC<IProps> = ({ isVisible }) => {
	const { setGroup, selectedGroup, selectedLanguage, groups, loading } =
		useContext<ILocalizationContext>(LocalizationContext);
	const { customerLanguages } = useContext<IEditCustomerContext>(EditCustomerContext);
	const [isFirstEntry, setIsFirstEntry] = useState<boolean>(true);
	const activeGroup = groups.find((el) => el.id === selectedGroup?.id) ?? groups[0];

	useEffect(() => {
		if (isFirstEntry && loading) {
			setIsFirstEntry(false);
		}
	}, [loading]);

	return (
		<div className={classNames('p-4', { hidden: !isVisible })} data-test="LocalizationForm">
			{activeGroup ? (
				<div className="flex items-start gap-4">
					<FormSideTabs>
						{groups.map((el) => (
							<FormSideTab
								key={el.id}
								translationKey={el.name}
								translationNameSpace="localizationSettings"
								isActive={el.id === activeGroup.id}
								testId="SidebarItem"
								onClick={() => setGroup({ id: el.id, name: el.name })}
							/>
						))}
					</FormSideTabs>
					<div className="min-w-0 flex-1 flex flex-col gap-4">
						<LanguageBar items={customerLanguages} />
						{selectedLanguage?.id && (
							<LocalizationGroup
								key={`${activeGroup.id}-${selectedLanguage.id}`}
								group={activeGroup}
								languageId={selectedLanguage.id}
							/>
						)}
					</div>
				</div>
			) : (
				!loading && !isFirstEntry && <NoDataNew />
			)}
			<ModalWindows />
		</div>
	);
};
